import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Renders the official platform logo SVG for a given platform.
 * SVG paths sourced from the Figma design file (nodes 3570:135700, 3570:135704, 3570:135708).
 *
 * @Input platform  One of: 'youtube' | 'youtube-ctv' | 'tiktok' | 'meta'
 * @Input size      Icon size in px (default: 16). Height auto-scales per aspect ratio.
 */
@Component({
  selector: 'sp-platform-icon',
  standalone: true,
  imports: [CommonModule],
  template: `
    <!-- YouTube / YouTube CTV -->
    <svg
      *ngIf="platform === 'youtube' || platform === 'youtube-ctv'"
      [attr.width]="size"
      [attr.height]="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814z"
        fill="#FF0000"
      />
      <path d="M9.545 15.568V8.432L15.818 12l-6.273 3.568z" fill="#ffffff"/>
    </svg>

    <!-- TikTok -->
    <svg
      *ngIf="platform === 'tiktok'"
      [attr.width]="size"
      [attr.height]="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.75a8.16 8.16 0 0 0 4.77 1.52V6.83a4.85 4.85 0 0 1-1-.14z"
        fill="#010101"
      />
    </svg>

    <!-- Meta -->
    <svg
      *ngIf="platform === 'meta'"
      [attr.width]="size * 1.5"
      [attr.height]="size"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 16.5C3 12.5 5 8.5 8 8.5c2 0 3.5 1.5 5.5 4.5l1.5 2.5c2 3 3.5 4.5 5.5 4.5 2 0 3.5-2 5-5L27 13c1.5-3 3-4.5 5-4.5 3 0 5 4 5 8a5.5 5.5 0 0 1-4.5 5.5c-2.5 0-4.5-2-6.5-5.5L25 15c-2-3.5-3-5-4.5-5s-2.5 2-4.5 5l-1.5 2.5C12.5 21 10.5 23 8 23A5.5 5.5 0 0 1 3 16.5z"
        fill="#206CCF"
      />
    </svg>
  `,
})
export class PlatformIconComponent {
  @Input() platform = '';
  @Input() size = 16;
}
